import { Col, Row } from 'react-bootstrap';

export const Skeleton = ({ width, height = '1rem', className = '', style = {} }) => (
  <div
    className={`skeleton ${className}`}
    style={{ width, height, ...style }}
    aria-hidden="true"
  />
);

export const DeviceCardSkeleton = () => (
  <div className="col-md-4 mb-4">
    <div className="app-surface-card p-4 h-100">
      <Skeleton width="60%" height="1.5rem" className="mb-3" />
      <Skeleton width="40%" height="1rem" className="mb-2" />
      <Skeleton width="80%" height="1rem" className="mb-3" />
      <Skeleton width="100%" height="40px" className="mb-3" />
      <div className="d-flex gap-2">
        <Skeleton width="30%" height="2rem" />
        <Skeleton width="30%" height="2rem" />
      </div>
    </div>
  </div>
);

export const DashboardSkeleton = () => (
  <>
    <Row className="mb-4 g-3">
      {[1, 2, 3].map((i) => (
        <Col md={4} key={i}>
          <div className="app-stat-card p-3">
            <Skeleton width="50%" height="1rem" className="mb-2" />
            <Skeleton width="30%" height="2rem" />
          </div>
        </Col>
      ))}
    </Row>
    <Row>
      {[1, 2, 3].map((i) => (
        <DeviceCardSkeleton key={i} />
      ))}
    </Row>
  </>
);

export const MetricCardSkeleton = () => (
  <Col md={4} className="mb-4">
    <div className="sensor-card p-4" style={{ minHeight: 160 }}>
      <Skeleton width="70%" height="1.25rem" className="mb-3 skeleton-on-gradient" />
      <Skeleton width="40%" height="2.5rem" className="mb-2 skeleton-on-gradient" />
      <Skeleton width="50%" height="1rem" className="skeleton-on-gradient" />
    </div>
  </Col>
);

export const DeviceDashboardSkeleton = () => (
  <>
    <div className="app-status-strip mb-4 p-3">
      <Skeleton width="120px" height="1.5rem" />
      <Skeleton width="180px" height="1rem" />
    </div>
    <Row>
      {[1, 2, 3].map((i) => (
        <MetricCardSkeleton key={i} />
      ))}
    </Row>
  </>
);

export const ChartSkeleton = () => (
  <div className="app-chart-panel p-4 mb-4">
    <Skeleton width="200px" height="1.5rem" className="mb-3" />
    <Skeleton width="100%" height="400px" />
  </div>
);

export default Skeleton;